import React from 'react'
import Configurable from 'organization/Event/Configurable'
import PurchaseFormButton, {
  PurchaseFormButtonProps,
} from 'Event/Marketplace/Block/PurchaseForm/PurchaseFormButton'
import PurchaseFormButtonConfig from 'organization/Marketplace/config/BlockConfig/PurchaseFormButtonConfig'

export default function ConfigurablePurchaseFormButton(
  props: PurchaseFormButtonProps,
) {
  return (
    <Configurable aria-label={`edit purchase form button`}>
      <PurchaseFormButtonConfig {...props} />
      <PurchaseFormButton {...props} />
    </Configurable>
  )
}
